<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >

        <el-input
          style="width: 100%"
          v-model="strategyName"
          placeholder="策略名称"
          clearable
        ></el-input>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="type"
          placeholder="选择策略"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in sourceTypeList"
            :key="index"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="status"
          placeholder="策略状态"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in statusList"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        type="info"
        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        v-if="isAuth('wx:forward:strategy:save')"
        class="add-btn btn box-item"
        @click="addHandle"
      >新增</vs-button>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "queryHeader",
  data() {
    return {
      strategyName: '',
      type: '',
      sourceTypeList: [
        {key:3,name:'Webhook'},
        {key:2,name:'个人微信'},
        {key:1,name:'微信公众号'},
        {key:4,name:'其他(爬虫)'},
        {key:5,name:'Telegram Bot'},
        {key:6,name:'Lark应用'},
      ],
      status: '',
      statusList:[
        {value:0,name:'禁用'},
        {value:1,name:'启用'},
      ],

    }
  },
  methods: {
    toQuery(){
      this.$emit('toQuery');
    },
    searchHandle(){
      this.$emit('searchHandle')
    },
    addHandle(){
      this.$emit('addHandle');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {

  .header-sub-item {
    width: 100%;
  }
}
</style>
